define([
    "dojo/_base/lang",
    "dojo/dom-style",
    "dojo/dom-construct",
    "csi/action",
    "Workflow/UTCController"
], function(lang,domStyle,domConstruct,csiAction,UTCController) {

    // ovewrite Workflow tasks controller to add a digital signature
    csiAction.registerControllers("", {
        ApproveTask: "CFCA.ActionItemStepController",
        CompleteTask: "CFCA.ActionItemStepController",
        RejectTask: "CFCA.ActionItemStepController"
    });

	return {
	    /**
	     * Draw a button to the right of the field
	     */
        drawSelectDigitalCertificateButton: function(/*Form*/form, /*String*/fieldName, /*String*/actionId) {
            var field = form.defView.getField(fieldName);
            var tr = form.getFieldRow(field);

            var td = field.getDomNode().parentNode;

            var span = domConstruct.create("span", {style: "width: 100%"}, td);

            var ctx = form.getContext(form.getFormNodeUrl(true));

            var button = form.getAction(actionId).toHtmlWithAccess(ctx, span);

            domStyle.set(button, {
                marginLeft: "5px",
                padding: "0",
                position: "relative",
                top: "1px",
                width: "auto"
            });

            form.publishDomChange();
        }
	};
});